import ScreenReaderOnly from './screenReaderOnly.styles';

export default ScreenReaderOnly;
